import React, {useEffect, useRef, useState} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import  {Carousel} from "react-responsive-carousel";
import "./carousel.styles.scss";
import mainBackground from '../../assets/images/background.png';





const CarouselComponent = () => {
    
    const translateRef = useRef();
    const carouselRef = useRef();
    const [speed, setSpeed] = useState(0.2)

    const scrollFunction = () => {
        let scroll = window.pageYOffset;
        let calc = (scroll / 1000 + 0.5) - 1;
              
        let opacity = (1 - calc) * 1.2;
      
        carouselRef.current.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, ${opacity }), 
        rgba(0, 0, 0, ${opacity})), url(${mainBackground})`
        carouselRef.current.style.backgroundSize = 'cover';
        
    }

    useEffect(() => {
        if (carouselRef) {
            window.addEventListener('scroll', scrollFunction)
        }
        return () => {
            window.removeEventListener('scroll', scrollFunction);
        }
    }, [])
    
  return (
    <div className="carousel-container" ref={carouselRef}>
      <div className="carousel-large" ref={translateRef} data-speed={speed}>
        <Carousel
        
          showThumbs={false}
          showArrows={true}
          showStatus={false}
          autoPlay={true}
          infiniteLoop={true}
          transitionTime={1000}
          showIndicators={false}
        >
          <div>
            <p className="review">
            "Es una chica encantadora, tiene una voz
            excepcional y la velocidad de entrega y atención es
            inigualable. Muchas gracias Ingrid".
            </p>
            <p className="review-by neon">- ANDER FEBRER -<br/>
            INDEPENDENT PRODUCER</p>
            
          </div>
          <div>
            <p className="review">
            "She was very supportive on my idea. Ingrid worked with me until it was perfect. Such a smashing woman with talent". 
            </p>
            <p  className="review-by neon">- DJ TEKA -<br/>
            INDEPENDENT PRODUCER</p>
          </div>
          <div>
          <p className="review">
          "Ingrid is a superb (and fast!) professional. She always brings incredible energy and unimaginably good harmonies. Her voice was perfect for our kids audiobook"
            </p>
            <p className="review-by neon">- WINDY PRESS -<br/>
            PUBLISHING HOUSE</p>
          </div>
          <div>
          <p className="review">
          "Top, top, top! I always enjoy making tracks with Ingrid. Thanks!"
            </p>
            <p className="review-by">- ROBERT (D47) -<br/>
            INDEPENDENT PRODUCER</p>
          </div>
        </Carousel>
      </div>

    </div>
  );
};

export default CarouselComponent;
